import { useMemo } from 'react';
import { useGetEntitlementsQuery } from 'src/store/services';
import { useGetUser } from 'src/hooks';

export const useGetEntitlements = () => {
  const { user_id, isOpenTier } = useGetUser();

  const { data, isLoading, isFetching } = useGetEntitlementsQuery(
    {
      user_id,
    },
    {
      skip: isOpenTier || !user_id,
    },
  );

  return useMemo(
    () => ({
      entitlement: data,
      isLoading: isLoading || isFetching,
    }),
    [data, isLoading, isFetching],
  );
};
